import React from 'react';
import './ConnectionsDiagram.css';

const rows = [
  { label: 'Your value', text: 'I care about my health.' },
  { label: 'Your goal', text: 'Become stronger this year.' },
  { label: 'Your project', text: 'Run the 16-week program.' },
  { label: 'Your Tuesday', text: 'Thirty minutes at 6am.' },
];

export default function ConnectionsDiagram() {
  return (
    <section className="connections landing__section" aria-labelledby="connections-heading">
      <div className="landing__column">
        <div className="fade-up">
          <h2 className="connections__heading" id="connections-heading">
            Everything is connected<br />to something you care about.
          </h2>
          <p className="connections__lede">
            A task under a project under a goal under a value. A values card
            you wrote last October, reminding you why you're in this meeting
            today. The app holds the thread so you don't have to.
          </p>

          <div className="connections__diagram" role="img" aria-label="Hierarchy diagram: value → goal → project → daily task">
            <div className="connections__line" aria-hidden="true" />
            {rows.map((row, i) => (
              <div key={i} className="connections__row">
                <span className="connections__label">{row.label}</span>
                <span className="connections__text">{row.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
